import {
    HiOutlineRectangleStack,
    HiOutlineUserPlus,
    HiOutlineShoppingBag,
} from 'react-icons/hi2';
import { FaRegCircleUser } from 'react-icons/fa6';
import { ISidebarItem, ISidebarItemGroup } from './types';
import { Link } from 'react-router-dom';

import { sidebarKeys } from './sidebarMenuItems';
import { useTranslation } from 'react-i18next';

export const SIDEBAR_ICONS = {
    Store: <HiOutlineShoppingBag size={18} />,
    Orders: <HiOutlineRectangleStack size={18} />,
    SimManagement: <HiOutlineShoppingBag size={18} />,
    Profile: <FaRegCircleUser size={18} />,
    Referral: <HiOutlineUserPlus size={18} />,
};

function getSubMenus(t: (key: string) => string, key: string) {
    const subMenus: ISidebarItem[] = [];
    Object.keys(sidebarKeys[key].items).forEach((itemKey) => {
        const item = sidebarKeys[key].items[itemKey];
        subMenus.push({
            label: <Link to={item.URL}>{t(`sidebar.${item.key}`)}</Link>,
            key: item.key,
            disabled: item.disabled ?? false,
        });
    });
    return subMenus;
}
function getMenuItems(t: (key: string) => string) {
    const sidebarItems: ISidebarItemGroup[] = [];

    Object.keys(sidebarKeys).forEach((key) => {
        if (sidebarKeys[key].items) {
            sidebarItems.push({
                label: t(`sidebar.${sidebarKeys[key].key}`),
                key: sidebarKeys[key].key,
                icon: SIDEBAR_ICONS[key],
                items: getSubMenus(t, key),
                disabled: sidebarKeys[key].disabled ?? false,
                type: sidebarKeys[key]?.type,
            });
        } else {
            if (!sidebarKeys[key].hide)
                sidebarItems.push({
                    label: (
                        <Link to={sidebarKeys[key].URL}>
                            {t(`sidebar.${sidebarKeys[key].key}`)}
                        </Link>
                    ),
                    key: sidebarKeys[key].key,
                    icon: SIDEBAR_ICONS[key],
                    type: sidebarKeys[key]?.type,
                    disabled: sidebarKeys[key].disabled ?? false,
                });
        }
    });

    return sidebarItems as ISidebarItemGroup[];
}

export default function useSidebarMenuItems() {
    const { t } = useTranslation();

    const items = getMenuItems(t);

    return {
        items,
    };
}
